<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <h2>
          Predogled zaloge:
        </h2>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="print"
        >
          Tiskaj
          <v-icon right dark>mdi-printer</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>mdi-content-save-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="send"
          v-if="false"
        >
          Poslji
          <v-icon right dark>mdi-email-send-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          @click="closeWindow"
        >
          Prekliči
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="1" md="8" offset-md="2">
        <pdf
          class="pdf-preview"
          :src="`data:application/pdf;base64,${base64pdf}`"
          v-for="i in numPages"
          :key="i"
          :page="i"
          @num-pages="setPages($event)"
        ></pdf>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import printJS from 'print-js'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  props: ['dateTo', 'categories', 'reportType', 'includeSellDataType'],
  mixins: [
    asyncDataStatus
  ],
  components: {
    pdf
  },
  data () {
    return {
      base64pdf: null,
      fileName: '',
      numPages: 1
    }
  },
  methods: {
    ...mapActions('currentStock', ['getPdf']),
    print () {
      printJS({ printable: this.base64pdf, type: 'pdf', base64: true })
    },
    save () {
      const linkSource = `data:application/pdf;base64,${this.base64pdf}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = this.fileName
      downloadLink.click()
    },
    send () {

    },
    setPages (e) {
      console.log(e)
      if (e) {
        this.numPages = e
      }
    },
    closeWindow () {
      window.close()
    }
  },
  created () {
    this.getPdf({
      filters: {
        dateTo: this.dateTo || moment().format('YYYY-MM-DD'),
        categories: this.categories || '',
        reportType: this.reportType,
        includeSellDataType: this.includeSellDataType
      }
    })
      .then(response => {
        this.base64pdf = response.data
        this.fileName = response.filename
        this.asyncDataStatus_fetched()
      })
      .catch(anErr => {
        console.log(anErr)
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri pridobivanju zaloge.'
        })
      })
  }
}
</script>

<style scoped>
.pdf-preview {
  border: 1px solid black;
  margin-bottom: 10px;
}
</style>
